import { observer } from 'mobx-react';
import React from 'react';
import VietnamUploadsList from './vietnamUploadsList';

/**
 * 모(CP)/admin 전용: 전 회사 Vietnam 업로드 목록.
 * 접근 권한은 `vietnam-uploads-admin:read` (router의 VietnamUploadsAdminGuard).
 * 실제 전사 조회 허용 여부는 서버가 같은 권한으로 재검증한다 — scope=all은 요청 의도일 뿐이다.
 */
const VietnamUploadsAdminList: React.FC = () => <VietnamUploadsList scope="all" />;

export default observer(VietnamUploadsAdminList);
